export default __webpack_public_path__ + "static/media/lms_system_logo.c7cd73ce.png";